import { orchestrator } from 'satcheljs';
import { getTimePanelSelectedCalendarIdsMap } from 'owa-time-panel-selected-calendar-ids';
import {
    GetFolderIdsData,
    GetFolderIdsDataType,
    initializeUpNextEventLoader,
} from 'owa-upnext-event-loader';
import { ObservableMap } from 'mobx';
import { initializeUpNextV2 } from '../actions/publicActions';
import { getUserMailboxInfo } from 'owa-client-ids';

export default orchestrator(initializeUpNextV2, actionMessage => {
    let getFolderIdsData = new ObservableMap<string, GetFolderIdsData>();

    // Selected calendars are the calendars that the user has selected in the time panel. If the
    // user has not selected calendars in the time panel, the calendars that user has selected in Calendar module left nav are used.
    // For Upnext event we will get the upcoming event in any of these selected calendars
    const selectedCalendars = getTimePanelSelectedCalendarIdsMap();
    if (selectedCalendars.entries.length !== 0) {
        selectedCalendars.forEach((value, key) => {
            getFolderIdsData.set(key, {
                loaderType: GetFolderIdsDataType.CalendarIds,
                calendarIds: value,
            });
        });
    } else {
        getFolderIdsData.set(getUserMailboxInfo().primarySmtpAddress, {
            loaderType: GetFolderIdsDataType.DefaultCalendar,
        });
    }

    initializeUpNextEventLoader(getFolderIdsData, 'TimePanelAgenda_UpNextCalendarCacheId');
});
